<template>
  <li :class="[ns.b(), { [ns.e('center')]: center, [ns.is('horizontal')]: isHorizontal }]">
    <div :class="ns.e(!isHorizontal ? 'tail' : 'row-tail')" />
    <div
      v-if="!$slots.dot"
      :class="timelineKls"
      :style="{
        backgroundColor: color,
      }"
    >
      <sg-icon v-if="icon" :class="ns.e('icon')">
        <component :is="icon" />
      </sg-icon>
    </div>
    <div v-if="$slots.dot" :class="ns.e('dot')">
      <slot name="dot" />
    </div>

    <div :class="ns.e(!isHorizontal ? 'wrapper' : 'row-wrapper')">
      <div
        v-if="!hideTimestamp && placement === 'top'"
        :class="[ns.e('timestamp'), ns.is('top')]"
      >
        {{ timestamp }}
      </div>

      <div :class="ns.e('content')">
        <slot />
      </div>

      <div
        v-if="!hideTimestamp && placement === 'bottom'"
        :class="[ns.e('timestamp'), ns.is('bottom')]"
      >
        {{ timestamp }}
      </div>
    </div>
  </li>
</template>

<script lang="ts">
import { defineComponent, inject, computed } from 'vue'
import { SgIcon } from '@sgui-plus/components/icon'
import { useNamespace } from '@sgui-plus/hooks'
import { timelineItemProps } from './timeline-item'


type IsTimeLineProps = {
  horizontal: boolean
}

type IsTimeLineInject = {
  props: IsTimeLineProps
}

export default defineComponent({
  name: 'SgTimelineItem',

  components: {
    SgIcon,
  },

  props: timelineItemProps,

  setup(props) {
    const ns = useNamespace('timeline-item')
    const parent: IsTimeLineInject = inject('TimelineContextKey')!

    const isHorizontal = computed(() => {
      return parent.props.horizontal
    })

    const timelineKls = computed(() => [
      ns.e('node'),
      ns.em('node', props.size || ''),
      ns.em('node', props.type || ''),
      ns.is('hollow', props.hollow)
    ])

    return {
      ns,
      parent,
      isHorizontal,
      timelineKls
    }
  },
})
</script>
